import React from "react";
import { UiCardTitle } from "../../../components/common/UiCardTitle";
import {
    UiContentCol,
    UiContentWr,
} from "../../../components/common/UiPageElements";
import { UiStepsWizard } from "../../../components/common/UiStepsWizard";
import UiIncentiveHistoryCard from "./UiIncentiveHistoryCard";
import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../components/grid-container/GridContainer";
import {
    UiSalesChainElement,
    UiSalesChainElementNoBgWr,
} from "./UiSalesChainElements";
import { UiInput } from "../../../components/form/UiInput";
import { UiButtonPrimary } from "../../../components/form/UiButton";
import { UiSlider } from "../../../../_uiComponents/common/UiSlider";
import {
    UiNextArrow,
    UiPrevArrow,
} from "../../../../_uiComponents/common/UiSliderArrows";
import {
    userTypes,
    participantJobRoleIds,
    participantTypeIds
} from "../../../../../_redux/_constants";

import { useDispatch, useSelector } from "react-redux";
export const QuickReadSection = (props) => {
    const { latestAchievements, thingsToDo, auth } = useSelector((state) => {
        return {
            auth: state.auth,
        };
    });
    const salesBymonth = [
        {
            id: 0,
            month: "January",
            achievement: "£11,194",
            items: [
                {
                    id: 0,
                    salesContent: "Battery",
                    value: "£110",
                },
                {
                    id: 1,
                    salesContent: "Battery",
                    value: "£110",
                },
                {
                    id: 2,
                    salesContent: "Battery",
                    value: "£110",
                },
                {
                    id: 3,
                    salesContent: "Battery",
                    value: "£110",
                },
            ],
        },
        {
            id: 1,
            month: "February",
            achievement: "£11,194",
            items: [
                {
                    id: 0,
                    salesContent: "Battery",
                    value: "£110",
                },
            ],
        },
        {
            id: 2,
            month: "March",
            achievement: "£11,194",
            items: [
                {
                    id: 0,
                    salesContent: "Battery",
                    value: "£110",
                },
            ],
        },
        {
            id: 3,
            month: "April",
            achievement: "£11,194",
            items: [
                {
                    id: 0,
                    salesContent: "Battery",
                    value: "£110",
                },
            ],
        },
        {
            id: 4,
            month: "May",
            achievement: "£11,194",
            items: [
                {
                    id: 0,
                    salesContent: "Battery",
                    value: "£110",
                },
            ],
        },
    ];

    const SaleSlider = {
        dots: true,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        centerPadding: 30,
        slidesToScroll: 1,
        nextArrow: <UiNextArrow />,
        prevArrow: <UiPrevArrow />,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    infinite: true,
                },
            },
        ],
    };

    return (
        <>
            <UiRowContainer
                fluid="fluid"
                className="sb-incentive-process-wrapper sb-wizard-section-wrapper"
            >
                <UiCol lg="12" className={props.className}>
                    <UiSingleRow>
                        <UiCol lg="8">
                            <UiCardTitle title="Quick Read: Tips to succeed" />
                            {auth?.userProfileDetails.jobRoleId &&
                            auth?.userProfileDetails.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SERVICE_ADVISOR &&
                            auth?.userProfileDetails.roleId ==
                                participantTypeIds.PARTICIPANT ? (
                                <p>
                                    This quick guide will help to get you up and
                                    running. Remember every day matters during
                                    the campaign period. So make the most of
                                    your earning potential and ACT NOW.
                                </p>
                            ) : (
                                <p>
                                    This quick guide will help to get you up and
                                    running. Remember every day matters during
                                    the campaign period. So make the most of
                                    your earning potential and ACT NOW.
                                </p>
                            )}

                            <UiStepsWizard wizardData={props.wizardData} />
                        </UiCol>
                        <UiCol
                            lg="4"
                            className="sb-incentive-target-col sb-incentive-performance"
                        >
                            <UiIncentiveHistoryCard heading="Performance by month">
                                <UiSlider UiSliderSettings={SaleSlider}>
                                    {salesBymonth.map(
                                        (pageItems, indexPage) => {
                                            return (
                                                <div key={indexPage}>
                                                    <div className="sb-slider-content-wr">
                                                        <div className="sb-sales-card-heading">
                                                            <div className="sb-sales-card-heading__left">
                                                                <div className="sb-sales-card-heading__month">
                                                                    {
                                                                        pageItems.month
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div className="sb-sales-card-heading__right">
                                                                <div className="sb-sales-card-heading__total">
                                                                    Average
                                                                    Spend Per
                                                                    Visit ={" "}
                                                                    {
                                                                        pageItems.achievement
                                                                    }
                                                                </div>
                                                                <div className="sb-sales-card-heading__total">
                                                                    Target Spend
                                                                    Per Visit ={" "}
                                                                    {
                                                                        pageItems.achievement
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="sb-sales-value">
                                                            Average Value
                                                        </div>
                                                        <UiSalesChainElementNoBgWr>
                                                            {pageItems.items.map(
                                                                (
                                                                    element,
                                                                    index,
                                                                ) => {
                                                                    return (
                                                                        <UiSalesChainElement
                                                                            isActive={
                                                                                false
                                                                            }
                                                                            salesContent={
                                                                                element.salesContent
                                                                            }
                                                                            value={
                                                                                element.value
                                                                            }
                                                                        />
                                                                    );
                                                                },
                                                            )}
                                                        </UiSalesChainElementNoBgWr>
                                                    </div>
                                                </div>
                                            );
                                        },
                                    )}
                                </UiSlider>
                            </UiIncentiveHistoryCard>
                        </UiCol>
                    </UiSingleRow>
                </UiCol>
            </UiRowContainer>
        </>
    );
};
